import { Loader2 } from 'lucide-react';
import { useAiActivityStore } from '../../stores/ai-activity-store';

export function PromptLoaderOverlay() {
  const activeCount = useAiActivityStore((s) => s.activeCount);

  if (!activeCount) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-surface/70 backdrop-blur-sm cursor-wait">
      <div className="flex items-center gap-3 px-4 py-3 rounded-lg bg-surface border border-surface-lighter shadow-lg">
        <Loader2 size={18} className="animate-spin text-text" />
        <div className="text-sm text-text">Working on your prompt…</div>
      </div>
    </div>
  );
}
